import { JsonApiModelConfig, JsonApiModel, Attribute, HasMany, BelongsTo } from 'angular2-jsonapi';
import {Address} from "./address";
import {Site} from "./site";
import {Appointment} from "./appointment";

@JsonApiModelConfig({
  type: 'user'
})
export class User extends JsonApiModel {

  @Attribute()
  email: string;

  @Attribute()
  password: string;

  @Attribute()
  address: Address;

}




// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/models/user.ts